import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { CustomizeProvider } from './context';
import store from './store';

import { SocketContext, socket } from "./context/socket";


import "./Language/i8nxt"


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <SocketContext.Provider value={socket}>
    <Provider store={store}>
      <CustomizeProvider>
        <App />
      </CustomizeProvider>
    </Provider>
  </SocketContext.Provider>

);


reportWebVitals();
